import { Component, PipeTransform, Pipe } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellEditorParams } from 'ag-grid-community';

@Component({
  selector: 'mo-action-buttons',
  template: `
    <div
      *ngFor="let item of icons | filterButtons: params"
      class="allow-click"
      [ngClass]="item.class ?? 'material-symbols-outlined'"
      matTooltip="{{ item.title | translate }}"
      matTooltipClass="mo-tooltip"
      data-action-type="{{ item.action }}"
    >
      <mat-icon
        style="{{ item.color > '' ? 'color:' + item.color + ';' : '' }}{{
          item.style > '' ? item.style : ''
        }}"
        >{{ item.icon | translate }}</mat-icon
      >
    </div>
  `,
  styles: [
    `
:host
  height: 100%
  display: flex
  align-items: center
  justify-content: flex-start
  gap: 10px

mat-icon
  color: var(--primary-color)
`,
  ],
})
export class AgActionButtonsComponent implements ICellEditorAngularComp {
  public params: ICellEditorParams = {} as ICellEditorParams;
  public icons: Array<ActionButtonData> = [];

  getValue() {
    return null;
  }

  isPopup?(): boolean {
    return false;
  }

  isCancelBeforeStart?(): boolean {
    return true;
  }

  isCancelAfterEnd?(): boolean {
    return true;
  }

  focusIn?(): void {}

  focusOut?(): void {}

  getFrameworkComponentInstance?() {}

  agInit(params: ICellEditorParams): void {
    this.params = params;
    this.icons = (params as any).buttons as Array<ActionButtonData>;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}
}

@Pipe({
  name: 'filterButtons',
  pure: false,
})
export class FilterButtons implements PipeTransform {
  transform(items: any[], filter: ICellEditorParams): any {
    if (!items || !filter) {
      return items;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items.filter((item) => this.isShow(item, filter));
  }

  isShow(item: ActionButtonData, params: ICellEditorParams): boolean {
    if (item.isShow !== null && item.isShow !== undefined) {
      return item.isShow(item, params);
    }
    return true;
  }
}

export class ActionButtonData {
  public icon: string = '';
  public title: string = '';
  public action: string = '';
  public color: string | undefined = '';
  public class: string | undefined = 'material-symbols-outlined';
  public style: string | undefined = '';
  public isShow: (item: ActionButtonData, param: ICellEditorParams) => boolean =
    () => true;
}
